import { Plus } from "lucide-react";

/**
 * CustomFocusInput
 * Renders the custom focus area input panel (expanded or collapsed toggle button).
 * Extracted from CustomStep3_FocusAreas to reduce file size.
 */
const CustomFocusInput = ({
  showCustomInput,
  customInput,
  disabled,
  onInputChange,
  onAdd,
  onCancel,
  onKeyDown,
  onToggleShow,
}) => {
  if (!showCustomInput) {
    return (
      <button
        type="button"
        onClick={onToggleShow}
        disabled={disabled}
        className="w-full border rounded-lg p-4 text-left border-gray-700/50 dark:shadow-md shadow-sm hover:bg-white/20 dark:hover:border-white/30 hover:border-gray-200 transition-colors duration-200"
      >
        <h4 className="text-sm font-medium dark:text-purple-300 text-textSecondary mb-3 flex items-center gap-2">
          <Plus className="w-4 h-4" />
          Add Custom Focus Area
        </h4>
      </button>
    );
  }

  return (
    <div className="w-full border rounded-lg p-4 text-left border-gray-700/50 dark:shadow-md shadow-sm transition-colors duration-200">
      <h4 className="text-sm font-medium dark:text-purple-300 text-textSecondary mb-3 flex items-center gap-2">
        <Plus className="w-4 h-4" />
        Add Custom Focus Area
      </h4>
      <div className="flex gap-2">
        <input
          type="text"
          value={customInput}
          onChange={onInputChange}
          placeholder="e.g., React & Frontend Development"
          className="flex-1 bg-white/10 border border-white/30 rounded-lg px-3 py-2 dark:text-white text-textSecondary text-sm placeholder-gray-400 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition-all backdrop-blur-sm"
          onKeyDown={onKeyDown}
          disabled={disabled}
          autoFocus
          maxLength={50}
        />
        <button
          type="button"
          onClick={onAdd}
          disabled={!customInput.trim() || disabled}
          className="bg-purple-600 hover:bg-purple-500 text-white px-4 py-2 rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Add
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="bg-gray-600 hover:bg-gray-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CustomFocusInput;
